import { ReactNode, useMemo } from "react"
import { useConcept } from "../../../redux/selectConcept"
import L1ErrorBlock from "../l1/L1ErrorBlock"
import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { Concept } from "@fusion-advantage/formlib"

interface useConceptValidatorProps {
	tagName: string
	cid?: string
	requireConcept: boolean
	allowDataTypes?: ConceptValueDataType[]
}

interface useConceptValidatorReturn {
	concept: Concept|null
	errorNode: ReactNode|null
}

export const useConceptValidator = ({
	tagName,
	cid,
	requireConcept,
	allowDataTypes = [],
}: useConceptValidatorProps): useConceptValidatorReturn => {
	const concept = useConcept(cid)
	let errorNode: ReactNode = useMemo(() => {
		if(!requireConcept) {
			return null
		}
		if(!cid || cid === '') {
			return <L1ErrorBlock content={`[${tagName}] no cid specified`} />
		}
		if(!concept) {
			return <L1ErrorBlock content={`[${tagName} ${cid}] concept not found`} />
		}
		if(allowDataTypes.length > 0) {
			if(!concept.valueDataType) {
				return <L1ErrorBlock content={`[${tagName} ${cid}] concept has null valueDataType`} />
			}
			if(!allowDataTypes.includes(concept.valueDataType)) {
				return <L1ErrorBlock content={`[${tagName} ${cid}] concept has invalid valueDataType ${concept.valueDataType}`} />
			}
		}
		return null
	}, [requireConcept, cid, tagName, concept, allowDataTypes])
	return {
		concept,
		errorNode,
	}
}
